import { getOwaTimezoneStrings } from 'owa-strings/owa-timezone-strings';
import getTimeZoneNameInServerLanguage from './getTimeZoneNameInServerLanguage';

/**
 * Gets the localized display name of a time zone.
 * See owa-strings\packages\owa-timezone-strings\createTimeZoneNames.ps1 for how keys are encoded.
 *
 * @param timeZoneId time zone ID. Usually this comes from TimeZoneEntry.Value.
 */
export default function getTimeZoneDisplayName(timeZoneId: string | null | undefined): string {
    const r = { '-': 'm', '+': 'p' };
    const key = (timeZoneId || '').replace(/-|\+|[\.| |\(|\)]/g, c => r[c] || '');
    return getOwaTimezoneStrings()[key] || getTimeZoneNameInServerLanguage(timeZoneId);
}
